import * as React from "react";

export const Background = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" {...props}>
		<path
			fill="#00365F"
			fillOpacity={ .9 }
			d="m0 64 60 21.3C120 107 240 149 360 160s240-11 360-26.7c120-16.3 240-26.3 360-26.6 120 .3 240 10.3 300 16l60 5.3v192H0Z"
		/>
	</svg>
);